export default __webpack_public_path__ + "static/media/chess-fianchetto-book(reduced).cddbc769.webp";